import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const EmailInline: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M3.725 4.5h17.55c.539 0 .975.373.975.833v13.334c0 .46-.436.833-.975.833H3.725c-.538 0-.975-.373-.975-.833V5.333c0-.46.437-.833.975-.833zM20.3 8.032l-7.127 5.454a1 1 0 01-1.21.005L4.7 8.013v9.82h15.6V8.032zM5.199 6.167l7.361 5.551 7.254-5.551H5.199z"
      fill={color}
    />
  </svg>
)
